// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --accent: #33ffd6;
    --accent-alt: #6d5bff;
    --bg: radial-gradient(circle at 30% 30%, #14233b, #060b14 60%);
    --glass: rgba(255, 255, 255, 0.06);
    --glass-border: rgba(255, 255, 255, 0.15);
    --text: #e6ecf5;
    --muted: #92a1b3;
    --danger: #ff3b30;
    --radius: 18px;
    --transition: cubic-bezier(.25, .8, .25, 1);
}

* {
    box-sizing: border-box;
}

body {
    margin: 0;
    font-family: 'Inter', system-ui, -apple-system, 'Helvetica Neue', Arial, sans-serif;
    background: var(--bg);
    color: var(--text);
    -webkit-font-smoothing: antialiased;
    overflow-x: hidden;
}

h1, h2, h3 {
    font-weight: 600;
    margin: 0 0 1rem;
}

p {
    line-height: 1.5;
    margin: 0 0 1.1rem;
}

.site-header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: .7rem 1.4rem;
    backdrop-filter: blur(16px);
    background: linear-gradient(135deg, rgba(15, 25, 40, .75), rgba(10, 15, 25, .42));
    border-bottom: 1px solid var(--glass-border);
}

.logo-area .brand {
    font-weight: 600;
    letter-spacing: .5px;
}

.main-nav ul {
    list-style: none;
    display: flex;
    gap: 1.2rem;
    margin: 0;
    padding: 0;
}

.main-nav a {
    text-decoration: none;
    color: var(--muted);
    font-size: .85rem;
    position: relative;
}

.main-nav a::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -6px;
    height: 2px;
    width: 0;
    background: linear-gradient(90deg, var(--accent), var(--accent-alt));
    transition: width .35s var(--transition);
}

.main-nav a:hover {
    color: #fff;
}

.main-nav a:hover::after {
    width: 100%;
}

.lang-switch {
    display: flex;
    gap: .5rem;
}

.lang-btn {
    background: linear-gradient(135deg, #1b2c46, #0e1622);
    border: 1px solid var(--glass-border);
    color: var(--muted);
    font-size: .7rem;
    padding: .45rem .8rem;
    border-radius: 30px;
    cursor: pointer;
    transition: .3s;
}

.lang-btn.active, .lang-btn:hover {
    background: linear-gradient(135deg, var(--accent-alt), var(--accent));
    color: #061019;
    box-shadow: 0 0 10px -2px var(--accent);
}

.mobile-toggle {
    display: none;
    background: none;
    border: none;
    cursor: pointer;
}

.mobile-toggle span {
    width: 24px;
    height: 2px;
    display: block;
    margin: 5px 0;
    background: #fff;
    transition: .4s;
}

.hero {
    min-height: 88vh;
    padding: 7rem 1.6rem 4.5rem;
    display: grid;
    grid-template-columns: minmax(300px, 560px) 1fr;
    gap: 2rem;
    align-items: center;
    position: relative;
}

.hero-visual {
    position: relative;
    width: 100%;
    aspect-ratio: 16/9;
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid var(--glass-border);
    border-radius: 18px;
    overflow: hidden;
    box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.6), 0 0 18px -6px var(--accent);
    backdrop-filter: blur(6px) saturate(140%);
}

.hero-visual iframe {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border: 0;
    box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.35);
}

.hero-visual::before {
    content: '';
    position: absolute;
    inset: 0;
    pointer-events: none;
    border-radius: inherit;
    background: linear-gradient(180deg, rgba(109, 91, 255, 0.18), rgba(51, 255, 214, 0.12));
    mix-blend-mode: soft-light;
}

@media (max-width: 768px) {
    .hero {
        grid-template-columns: 1fr;
        gap: 1.4rem;
        padding-bottom: 5rem;
    }

    .hero-visual {
        aspect-ratio: 4/3;
    }

    .scroll-indicator {
        bottom: -36px;
        width: 28px;
        height: 50px;
        padding-top: 5px;
    }
}

.hero-content h1 {
    font-size: clamp(2rem, 5vw, 3.4rem);
    background: linear-gradient(90deg, #d9e6ff, #9fbfff 40%, #fff);
    -webkit-background-clip: text;
    color: transparent;
    animation: glowText 5s linear infinite;
}

@keyframes glowText {
    0%, 100% {
        filter: drop-shadow(0 0 0 var(--accent));
    }
    50% {
        filter: drop-shadow(0 0 8px var(--accent));
    }
}

.lead {
    color: var(--muted);
    max-width: 60ch;
}

.cta-group {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    margin: 1.4rem 0 2rem;
}

.btn {
    --pad: .95rem 1.4rem;
    display: inline-flex;
    align-items: center;
    gap: .6rem;
    padding: var(--pad);
    font-size: .8rem;
    letter-spacing: .5px;
    border-radius: 50px;
    text-decoration: none;
    cursor: pointer;
    border: 1px solid var(--accent);
    position: relative;
    transition: .4s var(--transition);
}

.btn.neon {
    background: linear-gradient(120deg, var(--accent-alt) -10%, var(--accent) 60%);
    color: #061019;
    font-weight: 600;
    box-shadow: 0 0 12px -2px var(--accent);
    width: fit-content;
    padding: .8rem 3rem;
}

.btn.neon:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 18px -8px var(--accent);
}

.btn.outline {
    background: rgba(255, 255, 255, .05);
    color: var(--accent);
}

.btn.outline:hover {
    background: rgba(255, 255, 255, .15);
}

.trust-badges {
    display: flex;
    gap: .8rem;
    flex-wrap: wrap;
}

.badge {
    padding: .45rem .75rem;
    background: rgba(255, 255, 255, .05);
    border: 1px solid var(--glass-border);
    font-size: .65rem;
    border-radius: 14px;
    backdrop-filter: blur(6px);
}

.hero-canvas {
    width: 100%;
    height: 480px;
    background: transparent;
}

.scroll-indicator {
    position: absolute;
    bottom: -24px;
    left: 50%;
    transform: translateX(-50%);
    width: 32px;
    height: 54px;
    border: 2px solid var(--accent);
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-top: 6px;
    z-index: 2;
    pointer-events: none;
}

.scroll-indicator span {
    width: 6px;
    height: 6px;
    background: var(--accent);
    border-radius: 50%;
    margin-top: 8px;
    animation: scrollDot 2.4s ease-in-out infinite;
}

@keyframes scrollDot {
    0% {
        transform: translateY(0);
        opacity: 1;
    }
    60% {
        transform: translateY(20px);
        opacity: 0;
    }
    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

.glass-section, .inventory-section, .about-section, .contact-section {
    padding: 4rem 1.6rem;
    position: relative;
}

.glass-section {
    background: var(--glass);
    border: 1px solid var(--glass-border);
    border-radius: var(--radius);
    backdrop-filter: blur(12px) saturate(140%);
    margin: 2rem 1.2rem;
    box-shadow: 0 8px 32px -8px rgba(0, 0, 0, .55);
}

h2 {
    font-size: clamp(1.6rem, 3.2vw, 2.2rem);
    background: linear-gradient(90deg, var(--accent), var(--accent-alt));
    -webkit-background-clip: text;
    color: transparent;
}

.features-grid {
    list-style: none;
    display: grid;
    gap: .9rem;
    padding: 0;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
}

.features-grid li {
    font-size: .9rem;
    background: rgba(255, 255, 255, .05);
    padding: .65rem .8rem;
    border: 1px solid var(--glass-border);
    border-radius: 12px;
}

.big-launch {
    display: inline-flex;
    align-items: center;
    gap: .8rem;
    padding: 1rem 1.4rem;
    background: linear-gradient(135deg, #13293d, #09141f);
    border: 1px solid var(--accent);
    color: var(--accent);
    border-radius: 14px;
    font-weight: 600;
    font-size: 1rem;
    text-decoration: none;
    transition: .4s;
}

.big-launch:hover {
    background: linear-gradient(135deg, var(--accent-alt), var(--accent));
    color: #061019;
    box-shadow: 0 0 24px -4px var(--accent);
}

.section-head {
    display: flex;
    flex-direction: column;
    gap: .8rem;
}

.filters {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
}

.filters label {
    font-size: .65rem;
    display: flex;
    flex-direction: column;
    gap: .35rem;
    color: var(--muted);
}

.filters select {
    background: #132331;
    color: #fff;
    border: 1px solid var(--accent-alt);
    border-radius: 8px;
    padding: .4rem .6rem;
    font-size: .75rem;
}

.car-grid {
    display: grid;
    gap: 1.8rem;
    margin-top: 2rem;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
}

.car-card {
    background: linear-gradient(145deg, #0d1621, #182b3d);
    border: 1px solid #1f354b;
    border-radius: 22px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    box-shadow: 0 8px 20px -10px rgba(0, 0, 0, .7);
    transition: transform .7s var(--transition), box-shadow .5s;
    cursor: pointer;
    transform-style: preserve-3d;
}

.car-card:hover {
    transform: rotateX(8deg) rotateY(8deg) translateY(-6px);
    box-shadow: 0 18px 42px -16px rgba(0, 0, 0, .8), 0 0 22px -6px var(--accent);
}

.car-thumb {
    position: relative;
}

.car-thumb img {
    width: 100%;
    height: 180px;
    object-fit: cover;
    filter: brightness(.9) contrast(1.05);
    transition: .6s;
}

.car-card:hover img {
    transform: scale(1.05);
    filter: brightness(1);
}

.tags {
    position: absolute;
    top: 10px;
    left: 10px;
    display: flex;
    gap: .4rem;
    flex-wrap: wrap;
}

.tag {
    background: rgba(0, 0, 0, .55);
    color: #fff;
    font-size: .55rem;
    padding: .25rem .5rem;
    border-radius: 30px;
    letter-spacing: .4px;
    border: 1px solid rgba(255, 255, 255, .15);
}

.car-info {
    padding: 1rem 1.1rem 1.3rem;
    display: flex;
    flex-direction: column;
    gap: .7rem;
}

.car-info h3 {
    margin: 0;
    font-size: 1rem;
}

.specs {
    display: flex;
    flex-wrap: wrap;
    gap: .5rem;
    font-size: .6rem;
    color: var(--muted);
}

.specs .price {
    font-weight: 600;
    background: linear-gradient(90deg, var(--accent), var(--accent-alt));
    -webkit-background-clip: text;
    color: transparent;
}

.viewer-links {
    display: flex;
    gap: .6rem;
    flex-wrap: wrap;
}

.viewer-links a {
    font-size: .6rem;
    padding: .45rem .75rem;
    text-decoration: none;
    background: linear-gradient(135deg, #13293d, #09141f);
    color: var(--accent);
    border: 1px solid var(--accent);
    border-radius: 10px;
    transition: .35s;
}

.viewer-links a:hover {
    background: linear-gradient(135deg, var(--accent-alt), var(--accent));
    color: #061019;
    box-shadow: 0 0 14px -4px var(--accent);
}

.about-grid {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
}

.about-card {
    background: rgba(255, 255, 255, .05);
    border: 1px solid var(--glass-border);
    padding: 1.3rem 1.2rem;
    border-radius: 18px;
    transition: .4s;
}

.about-card:not(:last-child) {
    margin-right: 1.4rem;
}

.about-card:hover {
    background: rgba(255, 255, 255, .09);
}

.about-section .about-contact {
    margin-top: 2rem;
    width: fit-content;
    min-width: 420px;
}

.about-section .about-contact address {
    font-style: normal;
    display: grid;
    gap: .5rem;
}

.about-section .about-contact p {
    margin: 0;
    color: var(--muted);
}

.about-section .about-contact p strong {
    color: var(--text);
    font-weight: 600;
}

.about-section .about-contact a {
    color: var(--accent);
    text-decoration: none;
    border-bottom: 1px dashed transparent;
    transition: color .25s var(--transition), border-color .25s var(--transition);
}

.about-section .about-contact a:hover {
    color: var(--accent);
    background: none;
    -webkit-background-clip: initial;
    border-bottom-color: var(--accent);
}

@media (max-width: 1200px) {
    .about-section .about-contact {
        max-width: 920px;
    }
}

@media (max-width: 980px) {
    .about-section .about-contact {
        max-width: 840px;
    }
}

@media (max-width: 760px) {
    .about-section .about-contact {
        max-width: 95%;
    }
}

.contact-form {
    max-width: 560px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.contact-form label {
    display: flex;
    flex-direction: column;
    gap: .4rem;
    font-size: .75rem;
}

.contact-form input, .contact-form textarea {
    background: #132331;
    border: 1px solid var(--accent-alt);
    border-radius: 10px;
    padding: .75rem .9rem;
    color: #fff;
    font-size: .75rem;
}

.contact-form input:focus, .contact-form textarea:focus {
    outline: 2px solid var(--accent);
    box-shadow: 0 0 0 4px rgba(51, 255, 214, .2);
}

.form-status {
    font-size: .8rem;
    min-height: 1rem;
    font-weight: 600;
}

.form-status.error {
    color: var(--danger);
}

.site-footer {
    margin-top: 3rem;
    padding: 2rem 1.6rem;
    border-top: 1px solid var(--glass-border);
    background: rgba(255, 255, 255, 0.04);
    backdrop-filter: blur(10px);
}

.footer-grid {
    display: grid;
    gap: 1.2rem;
    grid-template-columns: 1fr;
}

.footer-grid.center {
    justify-items: center;
    text-align: center;
}

.footer-brand h4 {
    margin: 0 0 .5rem;
}

.copyright {
    font-size: .75rem;
}

.footer-lang h4 {
    margin: 0 0 .5rem;
}

.observer-base {
    opacity: 0;
    transform: translateY(40px);
    transition: 1s var(--transition);
}

.observer-base.visible {
    opacity: 1;
    transform: translateY(0);
}

@media (max-width: 980px) {
    .hero {
        grid-template-columns:1fr;
        padding-top: 6rem;
    }
}

@media (max-width: 760px) {
    .main-nav {
        display: none;
        position: absolute;
        top: 60px;
        left: 0;
        right: 0;
        background: #0a1622;
        padding: 1rem 1.4rem;
    }

    .main-nav.open {
        display: block;
    }

    .main-nav ul {
        flex-direction: column;
        gap: .8rem;
    }

    .mobile-toggle {
        display: block;
    }

    .hero-content h1 {
        font-size: 2.3rem;
    }

    .trust-badges {
        justify-content: flex-start;
    }
}

@media (prefers-reduced-motion: reduce) {
    .scroll-indicator span, .car-card:hover, .hero-content h1 {
        animation: none;
    }

    .car-card:hover {
        transform: none;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/global.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,8DAA8D;IAC9D,kCAAkC;IAClC,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,mFAAmF;IACnF,qBAAqB;IACrB,kBAAkB;IAClB,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;IACrB,2BAA2B;IAC3B,iFAAiF;IACjF,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,SAAS;IACT,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,YAAY;IACZ,WAAW;IACX,QAAQ;IACR,oEAAoE;IACpE,wCAAwC;AAC5C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,qDAAqD;IACrD,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qEAAqE;IACrE,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,aAAa;IACb,+CAA+C;IAC/C,SAAS;IACT,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,qCAAqC;IACrC,mBAAmB;IACnB,gBAAgB;IAChB,6EAA6E;IAC7E,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,SAAS;IACT,8CAA8C;AAClD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,sBAAsB;IACtB,uFAAuF;IACvF,0BAA0B;AAC9B;;AAEA;IACI;QACI,0BAA0B;QAC1B,WAAW;QACX,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA;IACI,mCAAmC;IACnC,8DAA8D;IAC9D,6BAA6B;IAC7B,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI;QACI,wCAAwC;IAC5C;IACA;QACI,0CAA0C;IAC9C;AACJ;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,qBAAqB;AACzB;;AAEA;IACI,oBAAoB;IACpB,oBAAoB;IACpB,mBAAmB;IACnB,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,+BAA+B;IAC/B,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,8EAA8E;IAC9E,cAAc;IACd,gBAAgB;IAChB,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;IACpC,qCAAqC;IACrC,iBAAiB;IACjB,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,uBAAuB;IACvB,gBAAgB;IAChB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI;QACI,wBAAwB;QACxB,UAAU;IACd;IACA;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,qCAAqC;IACrC,4BAA4B;IAC5B,0CAA0C;IAC1C,mBAAmB;IACnB,8CAA8C;AAClD;;AAEA;IACI,uCAAuC;IACvC,oEAAoE;IACpE,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,UAAU;IACV,UAAU;IACV,2DAA2D;AAC/D;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,qBAAqB;IACrB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,UAAU;IACV,oBAAoB;IACpB,qDAAqD;IACrD,+BAA+B;IAC/B,oBAAoB;IACpB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,qEAAqE;IACrE,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,mCAAmC;IACnC,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,4DAA4D;AAChE;;AAEA;IACI,qDAAqD;IACrD,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,8CAA8C;IAC9C,2DAA2D;IAC3D,eAAe;IACf,4BAA4B;AAChC;;AAEA;IACI,uDAAuD;IACvD,4EAA4E;AAChF;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,qCAAqC;IACrC,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,aAAa;IACb,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,mBAAmB;IACnB,oBAAoB;IACpB,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;IAC3B,aAAa;IACb,sBAAsB;IACtB,UAAU;AACd;;AAEA;IACI,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,oEAAoE;IACpE,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,qDAAqD;IACrD,oBAAoB;IACpB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qEAAqE;IACrE,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,qCAAqC;IACrC,6EAA6E;AACjF;;AAEA;IACI,oBAAoB;IACpB,gBAAgB;IAChB,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;IACnC,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,yCAAyC;IACzC,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,gCAAgC;AACpC;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI;QACI,yBAAyB;QACzB,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,kBAAkB;QAClB,SAAS;QACT,OAAO;QACP,QAAQ;QACR,mBAAmB;QACnB,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,sBAAsB;QACtB,UAAU;IACd;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[":root {\n    --accent: #33ffd6;\n    --accent-alt: #6d5bff;\n    --bg: radial-gradient(circle at 30% 30%, #14233b, #060b14 60%);\n    --glass: rgba(255, 255, 255, 0.06);\n    --glass-border: rgba(255, 255, 255, 0.15);\n    --text: #e6ecf5;\n    --muted: #92a1b3;\n    --danger: #ff3b30;\n    --radius: 18px;\n    --transition: cubic-bezier(.25, .8, .25, 1);\n}\n\n* {\n    box-sizing: border-box;\n}\n\nbody {\n    margin: 0;\n    font-family: 'Inter', system-ui, -apple-system, 'Helvetica Neue', Arial, sans-serif;\n    background: var(--bg);\n    color: var(--text);\n    -webkit-font-smoothing: antialiased;\n    overflow-x: hidden;\n}\n\nh1, h2, h3 {\n    font-weight: 600;\n    margin: 0 0 1rem;\n}\n\np {\n    line-height: 1.5;\n    margin: 0 0 1.1rem;\n}\n\n.site-header {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 100;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: .7rem 1.4rem;\n    backdrop-filter: blur(16px);\n    background: linear-gradient(135deg, rgba(15, 25, 40, .75), rgba(10, 15, 25, .42));\n    border-bottom: 1px solid var(--glass-border);\n}\n\n.logo-area .brand {\n    font-weight: 600;\n    letter-spacing: .5px;\n}\n\n.main-nav ul {\n    list-style: none;\n    display: flex;\n    gap: 1.2rem;\n    margin: 0;\n    padding: 0;\n}\n\n.main-nav a {\n    text-decoration: none;\n    color: var(--muted);\n    font-size: .85rem;\n    position: relative;\n}\n\n.main-nav a::after {\n    content: '';\n    position: absolute;\n    left: 0;\n    bottom: -6px;\n    height: 2px;\n    width: 0;\n    background: linear-gradient(90deg, var(--accent), var(--accent-alt));\n    transition: width .35s var(--transition);\n}\n\n.main-nav a:hover {\n    color: #fff;\n}\n\n.main-nav a:hover::after {\n    width: 100%;\n}\n\n.lang-switch {\n    display: flex;\n    gap: .5rem;\n}\n\n.lang-btn {\n    background: linear-gradient(135deg, #1b2c46, #0e1622);\n    border: 1px solid var(--glass-border);\n    color: var(--muted);\n    font-size: .7rem;\n    padding: .45rem .8rem;\n    border-radius: 30px;\n    cursor: pointer;\n    transition: .3s;\n}\n\n.lang-btn.active, .lang-btn:hover {\n    background: linear-gradient(135deg, var(--accent-alt), var(--accent));\n    color: #061019;\n    box-shadow: 0 0 10px -2px var(--accent);\n}\n\n.mobile-toggle {\n    display: none;\n    background: none;\n    border: none;\n    cursor: pointer;\n}\n\n.mobile-toggle span {\n    width: 24px;\n    height: 2px;\n    display: block;\n    margin: 5px 0;\n    background: #fff;\n    transition: .4s;\n}\n\n.hero {\n    min-height: 88vh;\n    padding: 7rem 1.6rem 4.5rem;\n    display: grid;\n    grid-template-columns: minmax(300px, 560px) 1fr;\n    gap: 2rem;\n    align-items: center;\n    position: relative;\n}\n\n.hero-visual {\n    position: relative;\n    width: 100%;\n    aspect-ratio: 16/9;\n    background: rgba(255, 255, 255, 0.04);\n    border: 1px solid var(--glass-border);\n    border-radius: 18px;\n    overflow: hidden;\n    box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.6), 0 0 18px -6px var(--accent);\n    backdrop-filter: blur(6px) saturate(140%);\n}\n\n.hero-visual iframe {\n    position: absolute;\n    inset: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n    box-shadow: inset 0 0 30px rgba(0, 0, 0, 0.35);\n}\n\n.hero-visual::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    border-radius: inherit;\n    background: linear-gradient(180deg, rgba(109, 91, 255, 0.18), rgba(51, 255, 214, 0.12));\n    mix-blend-mode: soft-light;\n}\n\n@media (max-width: 768px) {\n    .hero {\n        grid-template-columns: 1fr;\n        gap: 1.4rem;\n        padding-bottom: 5rem;\n    }\n\n    .hero-visual {\n        aspect-ratio: 4/3;\n    }\n\n    .scroll-indicator {\n        bottom: -36px;\n        width: 28px;\n        height: 50px;\n        padding-top: 5px;\n    }\n}\n\n.hero-content h1 {\n    font-size: clamp(2rem, 5vw, 3.4rem);\n    background: linear-gradient(90deg, #d9e6ff, #9fbfff 40%, #fff);\n    -webkit-background-clip: text;\n    color: transparent;\n    animation: glowText 5s linear infinite;\n}\n\n@keyframes glowText {\n    0%, 100% {\n        filter: drop-shadow(0 0 0 var(--accent));\n    }\n    50% {\n        filter: drop-shadow(0 0 8px var(--accent));\n    }\n}\n\n.lead {\n    color: var(--muted);\n    max-width: 60ch;\n}\n\n.cta-group {\n    display: flex;\n    gap: 1rem;\n    flex-wrap: wrap;\n    margin: 1.4rem 0 2rem;\n}\n\n.btn {\n    --pad: .95rem 1.4rem;\n    display: inline-flex;\n    align-items: center;\n    gap: .6rem;\n    padding: var(--pad);\n    font-size: .8rem;\n    letter-spacing: .5px;\n    border-radius: 50px;\n    text-decoration: none;\n    cursor: pointer;\n    border: 1px solid var(--accent);\n    position: relative;\n    transition: .4s var(--transition);\n}\n\n.btn.neon {\n    background: linear-gradient(120deg, var(--accent-alt) -10%, var(--accent) 60%);\n    color: #061019;\n    font-weight: 600;\n    box-shadow: 0 0 12px -2px var(--accent);\n    width: fit-content;\n    padding: .8rem 3rem;\n}\n\n.btn.neon:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 6px 18px -8px var(--accent);\n}\n\n.btn.outline {\n    background: rgba(255, 255, 255, .05);\n    color: var(--accent);\n}\n\n.btn.outline:hover {\n    background: rgba(255, 255, 255, .15);\n}\n\n.trust-badges {\n    display: flex;\n    gap: .8rem;\n    flex-wrap: wrap;\n}\n\n.badge {\n    padding: .45rem .75rem;\n    background: rgba(255, 255, 255, .05);\n    border: 1px solid var(--glass-border);\n    font-size: .65rem;\n    border-radius: 14px;\n    backdrop-filter: blur(6px);\n}\n\n.hero-canvas {\n    width: 100%;\n    height: 480px;\n    background: transparent;\n}\n\n.scroll-indicator {\n    position: absolute;\n    bottom: -24px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 32px;\n    height: 54px;\n    border: 2px solid var(--accent);\n    border-radius: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    padding-top: 6px;\n    z-index: 2;\n    pointer-events: none;\n}\n\n.scroll-indicator span {\n    width: 6px;\n    height: 6px;\n    background: var(--accent);\n    border-radius: 50%;\n    margin-top: 8px;\n    animation: scrollDot 2.4s ease-in-out infinite;\n}\n\n@keyframes scrollDot {\n    0% {\n        transform: translateY(0);\n        opacity: 1;\n    }\n    60% {\n        transform: translateY(20px);\n        opacity: 0;\n    }\n    100% {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n.glass-section, .inventory-section, .about-section, .contact-section {\n    padding: 4rem 1.6rem;\n    position: relative;\n}\n\n.glass-section {\n    background: var(--glass);\n    border: 1px solid var(--glass-border);\n    border-radius: var(--radius);\n    backdrop-filter: blur(12px) saturate(140%);\n    margin: 2rem 1.2rem;\n    box-shadow: 0 8px 32px -8px rgba(0, 0, 0, .55);\n}\n\nh2 {\n    font-size: clamp(1.6rem, 3.2vw, 2.2rem);\n    background: linear-gradient(90deg, var(--accent), var(--accent-alt));\n    -webkit-background-clip: text;\n    color: transparent;\n}\n\n.features-grid {\n    list-style: none;\n    display: grid;\n    gap: .9rem;\n    padding: 0;\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n}\n\n.features-grid li {\n    font-size: .9rem;\n    background: rgba(255, 255, 255, .05);\n    padding: .65rem .8rem;\n    border: 1px solid var(--glass-border);\n    border-radius: 12px;\n}\n\n.big-launch {\n    display: inline-flex;\n    align-items: center;\n    gap: .8rem;\n    padding: 1rem 1.4rem;\n    background: linear-gradient(135deg, #13293d, #09141f);\n    border: 1px solid var(--accent);\n    color: var(--accent);\n    border-radius: 14px;\n    font-weight: 600;\n    font-size: 1rem;\n    text-decoration: none;\n    transition: .4s;\n}\n\n.big-launch:hover {\n    background: linear-gradient(135deg, var(--accent-alt), var(--accent));\n    color: #061019;\n    box-shadow: 0 0 24px -4px var(--accent);\n}\n\n.section-head {\n    display: flex;\n    flex-direction: column;\n    gap: .8rem;\n}\n\n.filters {\n    display: flex;\n    gap: 1rem;\n    flex-wrap: wrap;\n}\n\n.filters label {\n    font-size: .65rem;\n    display: flex;\n    flex-direction: column;\n    gap: .35rem;\n    color: var(--muted);\n}\n\n.filters select {\n    background: #132331;\n    color: #fff;\n    border: 1px solid var(--accent-alt);\n    border-radius: 8px;\n    padding: .4rem .6rem;\n    font-size: .75rem;\n}\n\n.car-grid {\n    display: grid;\n    gap: 1.8rem;\n    margin-top: 2rem;\n    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n}\n\n.car-card {\n    background: linear-gradient(145deg, #0d1621, #182b3d);\n    border: 1px solid #1f354b;\n    border-radius: 22px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 8px 20px -10px rgba(0, 0, 0, .7);\n    transition: transform .7s var(--transition), box-shadow .5s;\n    cursor: pointer;\n    transform-style: preserve-3d;\n}\n\n.car-card:hover {\n    transform: rotateX(8deg) rotateY(8deg) translateY(-6px);\n    box-shadow: 0 18px 42px -16px rgba(0, 0, 0, .8), 0 0 22px -6px var(--accent);\n}\n\n.car-thumb {\n    position: relative;\n}\n\n.car-thumb img {\n    width: 100%;\n    height: 180px;\n    object-fit: cover;\n    filter: brightness(.9) contrast(1.05);\n    transition: .6s;\n}\n\n.car-card:hover img {\n    transform: scale(1.05);\n    filter: brightness(1);\n}\n\n.tags {\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    display: flex;\n    gap: .4rem;\n    flex-wrap: wrap;\n}\n\n.tag {\n    background: rgba(0, 0, 0, .55);\n    color: #fff;\n    font-size: .55rem;\n    padding: .25rem .5rem;\n    border-radius: 30px;\n    letter-spacing: .4px;\n    border: 1px solid rgba(255, 255, 255, .15);\n}\n\n.car-info {\n    padding: 1rem 1.1rem 1.3rem;\n    display: flex;\n    flex-direction: column;\n    gap: .7rem;\n}\n\n.car-info h3 {\n    margin: 0;\n    font-size: 1rem;\n}\n\n.specs {\n    display: flex;\n    flex-wrap: wrap;\n    gap: .5rem;\n    font-size: .6rem;\n    color: var(--muted);\n}\n\n.specs .price {\n    font-weight: 600;\n    background: linear-gradient(90deg, var(--accent), var(--accent-alt));\n    -webkit-background-clip: text;\n    color: transparent;\n}\n\n.viewer-links {\n    display: flex;\n    gap: .6rem;\n    flex-wrap: wrap;\n}\n\n.viewer-links a {\n    font-size: .6rem;\n    padding: .45rem .75rem;\n    text-decoration: none;\n    background: linear-gradient(135deg, #13293d, #09141f);\n    color: var(--accent);\n    border: 1px solid var(--accent);\n    border-radius: 10px;\n    transition: .35s;\n}\n\n.viewer-links a:hover {\n    background: linear-gradient(135deg, var(--accent-alt), var(--accent));\n    color: #061019;\n    box-shadow: 0 0 14px -4px var(--accent);\n}\n\n.about-grid {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n}\n\n.about-card {\n    background: rgba(255, 255, 255, .05);\n    border: 1px solid var(--glass-border);\n    padding: 1.3rem 1.2rem;\n    border-radius: 18px;\n    transition: .4s;\n}\n\n.about-card:not(:last-child) {\n    margin-right: 1.4rem;\n}\n\n.about-card:hover {\n    background: rgba(255, 255, 255, .09);\n}\n\n.about-section .about-contact {\n    margin-top: 2rem;\n    width: fit-content;\n    min-width: 420px;\n}\n\n.about-section .about-contact address {\n    font-style: normal;\n    display: grid;\n    gap: .5rem;\n}\n\n.about-section .about-contact p {\n    margin: 0;\n    color: var(--muted);\n}\n\n.about-section .about-contact p strong {\n    color: var(--text);\n    font-weight: 600;\n}\n\n.about-section .about-contact a {\n    color: var(--accent);\n    text-decoration: none;\n    border-bottom: 1px dashed transparent;\n    transition: color .25s var(--transition), border-color .25s var(--transition);\n}\n\n.about-section .about-contact a:hover {\n    color: var(--accent);\n    background: none;\n    -webkit-background-clip: initial;\n    border-bottom-color: var(--accent);\n}\n\n@media (max-width: 1200px) {\n    .about-section .about-contact {\n        max-width: 920px;\n    }\n}\n\n@media (max-width: 980px) {\n    .about-section .about-contact {\n        max-width: 840px;\n    }\n}\n\n@media (max-width: 760px) {\n    .about-section .about-contact {\n        max-width: 95%;\n    }\n}\n\n.contact-form {\n    max-width: 560px;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.contact-form label {\n    display: flex;\n    flex-direction: column;\n    gap: .4rem;\n    font-size: .75rem;\n}\n\n.contact-form input, .contact-form textarea {\n    background: #132331;\n    border: 1px solid var(--accent-alt);\n    border-radius: 10px;\n    padding: .75rem .9rem;\n    color: #fff;\n    font-size: .75rem;\n}\n\n.contact-form input:focus, .contact-form textarea:focus {\n    outline: 2px solid var(--accent);\n    box-shadow: 0 0 0 4px rgba(51, 255, 214, .2);\n}\n\n.form-status {\n    font-size: .8rem;\n    min-height: 1rem;\n    font-weight: 600;\n}\n\n.form-status.error {\n    color: var(--danger);\n}\n\n.site-footer {\n    margin-top: 3rem;\n    padding: 2rem 1.6rem;\n    border-top: 1px solid var(--glass-border);\n    background: rgba(255, 255, 255, 0.04);\n    backdrop-filter: blur(10px);\n}\n\n.footer-grid {\n    display: grid;\n    gap: 1.2rem;\n    grid-template-columns: 1fr;\n}\n\n.footer-grid.center {\n    justify-items: center;\n    text-align: center;\n}\n\n.footer-brand h4 {\n    margin: 0 0 .5rem;\n}\n\n.copyright {\n    font-size: .75rem;\n}\n\n.footer-lang h4 {\n    margin: 0 0 .5rem;\n}\n\n.observer-base {\n    opacity: 0;\n    transform: translateY(40px);\n    transition: 1s var(--transition);\n}\n\n.observer-base.visible {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n@media (max-width: 980px) {\n    .hero {\n        grid-template-columns:1fr;\n        padding-top: 6rem;\n    }\n}\n\n@media (max-width: 760px) {\n    .main-nav {\n        display: none;\n        position: absolute;\n        top: 60px;\n        left: 0;\n        right: 0;\n        background: #0a1622;\n        padding: 1rem 1.4rem;\n    }\n\n    .main-nav.open {\n        display: block;\n    }\n\n    .main-nav ul {\n        flex-direction: column;\n        gap: .8rem;\n    }\n\n    .mobile-toggle {\n        display: block;\n    }\n\n    .hero-content h1 {\n        font-size: 2.3rem;\n    }\n\n    .trust-badges {\n        justify-content: flex-start;\n    }\n}\n\n@media (prefers-reduced-motion: reduce) {\n    .scroll-indicator span, .car-card:hover, .hero-content h1 {\n        animation: none;\n    }\n\n    .car-card:hover {\n        transform: none;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
